import gql from 'graphql-tag';

export const GET_CURRENT_POLICY = gql`
  query {
    weployer {
      policy {
        actions
        role
      }
    }
  }
`;

export default GET_CURRENT_POLICY;
